import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedAssetSelector($companyId: ID!, $id: ID) {
    assets(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        barcode {
          id
          barcode
        }
      }
    }
  }
`

export const Query = gql`
  query AssetSelector(
    $companyId: ID!,
    $filters: AssetFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    assets(companyId: $companyId, filters: $filters, order: { barcode: asc }, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        barcode {
          id
          barcode
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
